import { Injectable } from '@angular/core';
import { defaultLanguage, supportedLanguages, translations } from '../assets/i18n/translations';
import { AppConfigService } from '@app/services/app-config/app-config.service';

@Injectable()
export class TranslationService {
  constructor(public appConfigService: AppConfigService) {}

  getTranslation() {
    const browserLang = this.getBrowserCultureLang();
    let userLanguage = this.appConfigService.getUserLang();
    userLanguage = userLanguage || browserLang;
    const lang = supportedLanguages.includes(userLanguage) ? userLanguage : defaultLanguage;
    return translations[lang];
  }

  getBrowserCultureLang(): string {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
      return undefined;
    }

    let browserCultureLang: any = window.navigator.languages ? window.navigator.languages[0] : null;
    browserCultureLang =
      browserCultureLang ||
      window.navigator.language ||
      // tslint:disable-next-line:no-string-literal
      window.navigator['browserLanguage'] ||
      window.navigator['userLanguage'];

    return browserCultureLang;
  }
}
